var React = require('react');

function Mc (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#f31830","d":"M0 0h640v240H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 240h640v240H0z","key":1})]));
}

Mc.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Mc;

Mc.default = Mc;
